module.exports = __webpack_public_path__ + "static2024-7-11/img/shadow.22177f88.png";